import React from 'react';
import PropTypes from 'prop-types';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Box,
    useBreakpointValue
} from '@chakra-ui/react';
import {Link as RouterLink} from 'react-router-dom';
import data from '../../lang/arsskyrsla-data.json';

const Breadcrumbs = ({current, child, parent}) => {

    Breadcrumbs.propTypes = {
        current: PropTypes.string.isRequired,
        child: PropTypes.bool.isRequired,
        parent: PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string
        }),
    };

    const homepageLabel = data.versions[0].pages[0].breadcrumbLabel;
    const isMobile = useBreakpointValue({base: true, md: false});

    return (
        <Box ml="9px" mt={isMobile ? "156px" : "196px"} pb="25px">
            <Breadcrumb fontWeight='500' fontSize={isMobile ? "12px" : "14px"}>
                <BreadcrumbItem color="#60676B">
                    <BreadcrumbLink as={RouterLink} to="/">{homepageLabel}</BreadcrumbLink>
                </BreadcrumbItem>

                {child ?
                    <BreadcrumbItem color="#60676B">
                        <BreadcrumbLink as={RouterLink} to={`/${parent.link}`}>{parent.label}</BreadcrumbLink>
                    </BreadcrumbItem> : ""
                }

                <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink href='#'>{current}</BreadcrumbLink>
                </BreadcrumbItem>
            </Breadcrumb>
        </Box>
    );
};

export default Breadcrumbs;